import React from 'react';
import { useParams } from 'react-router-dom';

import { PathwayProgressState } from 'src/generated/webapp_gql';
import { CenteredSpinner } from 'src/shared/components/CenteredSpinner';
import { createRenderSwitch } from 'src/shared/components/RenderSwitch';

import { PathwayLanding } from './PathwayDetail/PathwayLanding';
import { PathwayCreated } from './PathwayDetail/PathwayCreated';
import { PathwayInProgress } from './PathwayDetail/PathwayInProgress';
import { PathwayFragment, MemberPathwayFragment } from '../../documents/fragments.generated';
import { usePathwayQuery } from '../../documents/pathway.generated';

export interface PathwayDetailProps {
    pathway: PathwayFragment;
    memberPathway: MemberPathwayFragment;
}

const Switch = createRenderSwitch<PathwayProgressState, PathwayDetailProps>();

export const PathwayPage = () => {
    const { uuid } = useParams<{ uuid: string }>();
    const { data, loading } = usePathwayQuery({
        variables: {
            uuid,
        },
        fetchPolicy: 'network-only',
    });

    if (!data?.pathway || loading) {
        return <CenteredSpinner />;
    }

    const { pathway } = data;
    const { memberPathway } = pathway;

    if (!memberPathway) {
        return <PathwayLanding pathway={pathway} />;
    }

    return (
        <Switch expression={memberPathway.state} data={{ pathway, memberPathway }}>
            <Switch.Case expression={PathwayProgressState.Cancelled} component={PathwayLanding} />
            <Switch.Case expression={PathwayProgressState.Created} component={PathwayCreated} />
            <Switch.Default component={PathwayInProgress} />
        </Switch>
    );
};
